<template>
    <modal ref="modal" @close="goBack()">
        <alert ref="alert"></alert>

        <div class="flex flex-col h-full w-full bg-purple-900 items-center justify-center">
            <div class="text-white text-center w-full">
                <h1 class="text-6xl px-20 lowercase font-light mb-20 md:mb-10">
                    {{ $t('credit_card') }}
                </h1>
            </div>

            <div v-if="loading">
                <div class="loader"></div>
            </div>

            <div v-show="!loading" class="pb-40 md:pb-10 text-white text-center w-full md:w-3/4 lg:w-5/6 p-10">
                <div v-show="showPay">
                    <div ref="card"></div>

                    <button :disabled="loading" class="btn btn-orange mt-2" @click="pay()">
                        {{ $t('pay') }}
                    </button>
                </div>

                <div class="pRequest">
                    <div ref="paymentRequest"></div>
                </div>
            </div>
        </div>
    </modal>
</template>

<style>
    .StripeElement {
        box-sizing: border-box;

        height: 40px;

        padding: 10px 12px;

        border: 1px solid transparent;
        border-radius: 4px;
        background-color: white;

        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }

    .pRequest .StripeElement {
        background-color: transparent!important;
    }

    .StripeElement--focus {
        /*box-shadow: 0 1px 3px 0 #cfd7df;*/
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
</style>

<script>
import {loadStripe} from '@stripe/stripe-js';
import {Zapin} from "../../services/Api";

export default {
        props: {
            plan: String,
            method: String
        },

        data() {
            return {
                loading: false,
                stripe: null,
                country: null,
                card: null,
                showPay: false
            }
        },

        mounted() {
            this.$refs.modal.open();

            this.startStripe()
                .then((stripe) => {
                    this.stripe = stripe;
                    // this.createRequestPaymentButton();
                    this.createCard();
                });
        },

        methods: {
            goBack() {
                history.go(-1);
            },

            createRequestPaymentButton() {
                Zapin
                    .plans()
                    .show(this.plan)
                    .then((res) => {
                        let plan = res.data;

                        const paymentRequest = this.stripe.paymentRequest({
                            country: 'US',
                            currency: plan.currency,
                            total: {
                                label: plan.name,
                                amount: plan.amount * 100,
                            },
                            // requestPayerName: true,
                            // requestPayerEmail: true
                        });

                        const btn = this.stripe.elements().create('paymentRequestButton', {
                            paymentRequest: paymentRequest
                        });

                        paymentRequest
                            .canMakePayment()
                            .then((r) => {
                                this.loading = false;

                                if(r) {
                                    btn.mount(this.$refs.paymentRequest);
                                } else {
                                    console.log('not supporting', r);

                                    this.createCard();
                                }
                            })

                        paymentRequest.on('paymentmethod', (ev) => {
                            this.loading = true;

                            this.subscribe(ev.paymentMethod)
                                .then(() => {
                                    ev.complete('success');
                                })
                                .catch(() => {
                                    ev.complete('fail');
                                })
                                .finally(() => this.loading = false);
                        })
                    })
            },

            createCard() {
                this.showPay = true;

                this.card = this
                    .stripe
                    .elements()
                    .create('card');

                this.card.mount(this.$refs.card);
            },

            async startStripe() {
                return await loadStripe(window.appConfig.services.stripe.key);
            },

            pay() {
                this.loading = true;

                this.stripe
                    .createPaymentMethod({
                        type: 'card',
                        card: this.card
                    })
                    .then(r => {
                        if(r.error) {
                            this.$refs.alert.show(r.error.message);
                            this.loading = false;
                            return;
                        }

                        this
                            .subscribe(r.paymentMethod)
                            .then(() => {
                                Zapin
                                    .updateUserData()
                                    .then(() => {
                                        this.$router.push({
                                            name: 'Dashboard'
                                        });
                                    })
                            })
                            .finally(() => this.loading = false);
                    })
                    .catch(err => {
                        console.error(err);

                        this.$refs
                            .alert
                            .show(this.$t('unknown_error_try_again'));

                        this.loading = false;
                    })
            },

            subscribe(paymentMethod) {
                return new Promise((resolve, reject) => {
                    Zapin
                        .payments()
                        .stripe()
                        .pay(this.plan, paymentMethod.id)
                        .then(res => {
                            this.$refs.alert.success(res.data.message);

                            resolve(res);
                        })
                        .catch(err => {
                            if(err.status === 428)
                                this.$refs.alert.show(err.data.data.message);

                            if(err.status === 422)
                                this.$refs.alert.showValidationErrors(err.data);

                            reject(err);
                        });
                })
            }
        }
    }
</script>